// MAGIC_DESPROCKET_START
//   ************THIS IS NOT THE RIGHT WAY TO STRUCTURE MODERN JS FILES************
//
//   For details and info on using this file see the wiki:
//     https://github.com/academia-edu/wiki/blob/master/development/formerly-sprockets-files.md
//
//   STATUS: auto generated
//   LOADERS:
//   ROOT: app/assets/webpack_entry/core_webpack.wjs.jsx
// MAGIC_DESPROCKET_END
// Sitewide Academia.edu-authored JS:
// - re-usable components
// - common business elements (navbar, signup/login/download/bookmark/message/follow buttons)
// - shared flux/redux stores
// - translations
//
// Does what you're adding belong in libraries_and_infrequently_changed.js,
// or a page-specific file?

//= require core_post_webpack
//= require search
//= require auth
//= require messages
//= require premium
//= require confirmation_banner
//= require certifications
//= require work_tags

//= require components

//= require i18n-js
//= require sprockets_canary

// This produces a "mismatched anonymous define" error if put in libraries_and_infrequently_changed.js, for some reason
//= require scroll-scope
// MAGIC_DESPROCKET_START
require('javascripts/core_post_webpack/index.js')
require('javascripts/search/index.js')
require('javascripts/auth/index.js')
require('javascripts/messages/index.js')
require('javascripts/premium/index.js')
require('javascripts/confirmation_banner/index.js')
require('javascripts/certifications/index.js')
require('javascripts/work_tags/index.js')
require('javascripts/components/index.js')
require('i18n-js/app/assets/javascripts/i18n.js')
require('javascripts/former-gems/rails-assets-scroll-scope-0.1.0/app/assets/javascripts/scroll-scope.js')
require('javascripts/former-gems/rails-assets-scroll-scope-0.1.0/app/assets/javascripts/scroll-scope/scroll-scope.js')
// MAGIC_DESPROCKET_END
